export default [
  {
    path: '/tela-favoritos',
    name: 'tela-favoritos',
    component: () => import('@/app-modulo/comuns/favoritos/TelaFavoritos.vue'),
    meta: {
      requiredAuth: true,
      action: 'auditar',
    },
  },
]
